module.exports = __webpack_public_path__ + "img/D201406_2.13037486.jpg";